import React from 'react';
import ProjectCard from './ProjectCard';
import './Projects.css';
import { projects } from './projectData';
import gwLogo from '../../resources/projects/gw-logo.png';

const featuredRole = {
  company: 'Gravity Well',
  logo: gwLogo as string,
  role: 'Junior Engineer',
  period: 'Jul 2026 – Present',
  location: 'Los Angeles, CA',
  bullets: [
    'Co-led split screen support for a AAA multiplayer title: resolving authentication across player sessions, fixing per-player controller input, and isolating post-processing to specific viewports.',
    'Diagnosed GPU-bound performance issues on Steam Deck (RDNA2), going from 15fps to a stable 40fps through memory analysis, instancing audits, and rendering configuration tuning.',
    'Built an interactive foliage system with Niagara and a ping-pong render target approach, enabling real-time foliage response to player interaction.'
  ]
};

const Projects: React.FC = () => {
  return (
    <div className="projects-container">
      <div className="featured-role">
        <div className="featured-role-left">
          {featuredRole.logo ? (
            <img
              src={featuredRole.logo}
              alt={featuredRole.company}
              className="featured-role-logo"
            />
          ) : (
            <div className="featured-role-logo-placeholder">{featuredRole.company.charAt(0)}</div>
          )}
        </div>
        <div className="featured-role-right">
          <div className="featured-role-header">
            <span className="featured-role-company">{featuredRole.company}</span>
            <span className="featured-role-divider" />
            <span className="featured-role-title">{featuredRole.role}</span>
            <span className="featured-role-period">{featuredRole.period}</span>
          </div>
          <ul className="featured-role-bullets">
            {featuredRole.bullets.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="projects-grid">
        {projects.map((project) => (
          <ProjectCard
            key={project.id}
            title={project.title}
            description={project.description}
            image={project.image}
            tags={project.tags}
          />
        ))}
      </div>
    </div>
  );
};

export default Projects;
